import { render, staticRenderFns } from "./SportelloMenuView.vue?vue&type=template&id=61414144&"
import script from "./SportelloMenuView.vue?vue&type=script&lang=ts&"
export * from "./SportelloMenuView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports